module.exports = __webpack_public_path__ + "static/case-6-c1a9f7be2baaebfc3b277d21986bd95b.jpg";